import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAuth } from '../../hooks/useAuth';

const LoadingContainer = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #1a365d 0%, #2c5282 100%)',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 9999,
}));

const LoadingScreen = ({ message = 'Loading...', showRefreshAfter = 5000 }) => {
  const { refreshProfile } = useAuth();
  const [showRefresh, setShowRefresh] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    if (showRefreshAfter > 0) {
      const timer = setTimeout(() => {
        setShowRefresh(true);
      }, showRefreshAfter);
      return () => clearTimeout(timer);
    }
  }, [showRefreshAfter]);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refreshProfile();
      window.location.reload();
    } catch (error) {
      console.error('Error refreshing:', error);
      alert('Failed to refresh. Please try again.');
    } finally {
      setRefreshing(false);
    }
  };

  const isSubscriptionMessage = message.toLowerCase().includes('subscription');

  return (
    <LoadingContainer>
      <CircularProgress 
        size={60}
        thickness={4}
        sx={{ 
          color: 'white',
          mb: 3
        }}
      />
      <Typography 
        variant="h6" 
        sx={{ 
          color: 'white',
          fontWeight: 500,
          mb: showRefresh && isSubscriptionMessage ? 3 : 0
        }}
      >
        {message}
      </Typography>
      
      {showRefresh && isSubscriptionMessage && (
        <Box sx={{ textAlign: 'center' }}>
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'rgba(255,255,255,0.8)',
              mb: 2,
              maxWidth: '300px'
            }}
          >
            Taking longer than expected? Try refreshing your subscription status.
          </Typography>
          <Button
            onClick={handleRefresh}
            disabled={refreshing}
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: 'white',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255,255,255,0.1)'
              }
            }}
          >
            {refreshing ? 'Refreshing...' : 'Refresh Status'}
          </Button>
        </Box>
      )}
    </LoadingContainer>
  );
};

export default LoadingScreen;
